import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { elementHandlers, elementInitialState, elementReducer } from '../reducers/ElementReducer';
import { ParentContext } from './ParentContext';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';

export const ElementContext = createContext();

const ElementProvider = (props) => {

  const { cn, elemProps, itemData } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states, settings } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state, storage_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { clientOptions, eventOptions, display: display_global } = aps_global ?? {}
  const { autoLinkPdfs, showAutoLinkIcons } = display_global ?? {}
  const _appOptions = { ...clientOptions, ...eventOptions }
  let { weatherZip } = _appOptions ?? {}

  const appUserAccess = useAppUserAccess()
  const { isAdminOrSuper } = appUserAccess ?? {}

  const { viewKey } = paps_state ?? {}

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)

  const { homeSettings } = settings
  const { global: global_home } = homeSettings ?? {}
  const { appUrls: homeAppUrls } = global_home ?? {}

  const { appStorageUrlFiles, galleries } = storage_state ?? {}

  const { pdf: global_pdf } = appStorageUrlFiles ?? {}
  const { pdf: gallery_pdf } = galleries ?? {}

  const opts = {
    autoLinkPdfs,
    gallery_pdf,
    global_pdf,
    homeAppUrls,
    isAdminOrSuper,
    isMobileDevice,
    showAutoLinkIcons,
    viewKey,
    weatherZip,
  }

  // isMobileDevice, homeAppUrls, weatherZip
  const init_state = { cn, elemProps, itemData, opts }
  const [element_state, element_dispatch] = useReducer(elementReducer, elementInitialState(init_state));

  const element_handlers = useMemo(
    () => elementHandlers(element_dispatch),
    [element_dispatch]
  );

  useEffect(() => {
    if (itemData) {
      element_handlers.handleInit_element(cn, elemProps, itemData, opts)
    }
  }, [element_handlers, itemData]);

  return (
    <ElementContext.Provider value={{ element_state, element_handlers }}>
      {props.children}
    </ElementContext.Provider>
  );
};

export default ElementProvider 